import React, { useState, useCallback } from "react";
import { Message, Button, Icon } from "semantic-ui-react";
import { auth } from "../../utils/firebase";

const VerifyEmailMessage = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);

  const onButtonPressed = useCallback(async () => {
    if (success) return;
    setLoading(true);
    setError(null);
    try {
      await auth.currentUser.sendEmailVerification();
      setSuccess(true);
    } catch (error) {
      setError("Failed to send verification email. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [success]);

  if (success) {
    return (
      <Message 
        success
        icon
        style={{ 
          marginTop: "1em",
          marginBottom: "1em"
        }}
      >
        <Icon name="check circle" />
        <Message.Content>
          <Message.Header>Verification Email Sent!</Message.Header>
          <p>Please check your email inbox and click the verification link to complete the process.</p>
        </Message.Content>
      </Message>
    );
  }

  return (
    <Message
      info
      icon
      style={{ 
        marginTop: "1em",
        marginBottom: "1em"
      }}
    >
      <Icon name="mail outline" />
      <Message.Content>
        <Message.Header>Email Verification Required</Message.Header>
        <p style={{ marginTop: "0.5em", marginBottom: "1em" }}>
          Please verify your email address to access all features and receive important updates.
        </p>
        {error && (
          <p style={{ color: "#d73502", marginBottom: "1em" }}>
            <Icon name="warning sign" /> {error}
          </p>
        )}
        <Button 
          primary 
          size="small"
          loading={loading}
          onClick={onButtonPressed}
        >
          <Icon name="send" />
          Send Verification Email
        </Button>
      </Message.Content>
    </Message>
  );
};

export default VerifyEmailMessage;
